import { OrchestrationTopics } from "./FilterTypes";
import { events } from "@otto-ec/global-resources/event-q-bus";

export type Topics = OrchestrationTopics;

export const eventQBus = events<Topics>();
